<template>
    <div id="gh-impact" class="gh-imapct">
        <div class="container">
            <el-row style="margin-bottom: 30px">
                <el-col :xs="24" :sm="12" :lg="13">
                    <p class="section-heading gh-header">Choose Your Impact &<br>Be a Champion for Children</p>
                </el-col>
                <el-col :xs="24" :sm="12" :lg="11" style="font-size: 1.23rem; line-height: 1.4">When you register for the Summit you decide how much you pay to attend. Your choice translates directly into support services for children and families in need.</el-col>
            </el-row>
            <div v-if="isMobile">
                <p style="font-size: 1.2rem; margin-bottom: 20px">Your Contribution (Select to learn more)</p>
                <el-tabs tab-position="top" v-model="activeName" type="border-card" @tab-click="handleClick" :value="choosedImpact">
                    <el-tab-pane label="$50" @click="updateRadio(50)" name="50">
                        <p class="gh-sub-heading" style="font-size: 25px; margin-bottom: 15px;">Appreciated</p>
                        <p class="gh-mobile-cell-body">What it translates to:</p>
                        <p><span class="gh-strong">Promote prevention*</span> by teaching a child to identify when they don’t feel safe and know safe adults they can ask for help.</p><br>
                        <p>*Delivered through Act for Kids’ Learn to be safe with Emmy and friends protective behaviours program facilitated for children in grade one at primary schools.</p>
                    </el-tab-pane>
                    <el-tab-pane label="$100" @click="updateRadio(100)" name="100">
                        <p class="gh-sub-heading" style="font-size: 25px; margin-bottom: 15px;">Most Popular</p>
                        <p class="gh-mobile-cell-body">What it translates to:</p>
                        <p><span class="gh-strong">Provide 1-hour of Integrated Therapy*</span> to an abused or neglected child, giving them the best chance to rebuild their life.</p><br>
                        <p>*Act for Kids’ Integrated Therapy Services are comprised of multidisciplinary teams that work with children, young people and their families to help them overcome their experiences.</p>
                    </el-tab-pane>
                    <el-tab-pane label="$200" @click="updateRadio(200)" name="200">
                        <p class="gh-sub-heading" style="font-size: 25px; margin-bottom: 15px;">Most Impactful</p>
                        <p class="gh-mobile-cell-body">What it translates to:</p>
                        <p><span class="gh-strong">Become a Champion*</span> for abused and neglected children by helping deliver assessment and free therapy services to children and their families.</p><br>
                        <p>*As a Champion you’ll help create the most positive change for children in need, and will receive a personalised “Champion for Children” Certificate, issued electronically by Act for Kids.</p>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <div v-else class="gh-desktop">
                <el-row class="gh-impact-table">
                    <el-col :xs="6" :sm="6" class="gh-table-header" style="text-align:left">Your impact</el-col>
                    <el-col :xs="6" :sm="6" class="gh-table-header" :style="selected50Style">Appreciated</el-col>
                    <el-col :xs="6" :sm="6" class="gh-table-header" :style="selected100Style">Most Popular</el-col>
                    <el-col :xs="6" :sm="6" class="gh-table-header" :style="selected200Style">Most Impactful</el-col>
                </el-row>
                <el-row class="gh-impact-table">
                    <el-col :xs="6" :sm="6" class="gh-table-header" style="text-align:left">Your contribution</el-col>
                    <el-col :xs="6" :sm="6" :style="selected50Style">$50</el-col>
                    <el-col :xs="6" :sm="6" :style="selected100Style">$100</el-col>
                    <el-col :xs="6" :sm="6" :style="selected200Style">$200</el-col>
                </el-row>
                <el-row class="gh-impact-table">
                    <el-col :xs="6" :sm="6" class="gh-table-header" style="text-align:left">What it translates to</el-col>
                    <el-col :xs="6" :sm="6" :style="selected50Style">
                        <p class="gh-cell-body"><span class="gh-strong">Promote prevention*</span> by teaching a child to identify when they don’t feel safe and know safe adults they can ask for help.</p>
                        <p class="gh-cell-description">*Delivered through Act for Kids’ Learn to be safe with Emmy and friends protective behaviours program facilitated for children in grade one at primary schools.</p>
                    </el-col>
                    <el-col :xs="6" :sm="6" :style="selected100Style">
                        <p class="gh-cell-body"><span class="gh-strong">Provide 1-hour of Integrated Therapy*</span> to an abused or neglected child, giving them the best chance to rebuild their life.</p>
                        <p class="gh-cell-description">*Act for Kids’ Integrated Therapy Services are comprised of multidisciplinary teams that work with children, young people and their families to help them overcome their experiences.</p>
                    </el-col>
                    <el-col :xs="6" :sm="6" :style="selected200Style">
                        <p class="gh-cell-body"><span class="gh-strong">Become a Champion* for abused and neglected children</span> by helping deliver assessment and free therapy services to children and their families.</p>
                        <p class="gh-cell-description">*As a Champion you’ll help create the most positive change for children in need, and will receive a personalised “Champion for Children” Certificate, issued electronically by Act for Kids.</p>
                    </el-col>
                </el-row>
                <el-row class="gh-impact-table">
                    <el-col :xs="6" :sm="6"></el-col>
                    <el-col :xs="6" :sm="6" :style="selected50Style">
                        <div class="gh-div-button">
                            <button :class="selectButtonClass" @click="updateRadio(50)">{{choosedImpact === 50 ? 'Selected' : 'Select'}}</button>
                        </div>
                    </el-col>
                    <el-col :xs="6" :sm="6" :style="selected100Style">
                         <div class="gh-div-button">
                            <button :class="selectButtonClass" @click="updateRadio(100)">{{choosedImpact === 100 ? 'Selected' : 'Select'}}</button>
                        </div>
                    </el-col>
                    <el-col :xs="6" :sm="6" :style="selected200Style">
                        <div class="gh-div-button">
                            <button :class="selectButtonClass" @click="updateRadio(200)">{{choosedImpact === 200 ? 'Selected' : 'Select'}}</button>
                        </div>
                    </el-col>
                </el-row>
            </div>

            <div class="gh-hint">
                Your choice of registration <span class="gh-strong">does not</span> affect your access to Summit presentations & content, only the social impact you’ll personally create with your registration. As 100% of your registration fees go directly to Act for Kids, we encourage you to be as impactful as you can – <span class="gh-strong">what you do matters.</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {

        props: {
            impact: {
                type: Number,
                default: 200
            }
        },

        data() {
            return {
                choosedImpact: 0,
                isMobile: false,
                activeName: '' + this.impact
            }
        },

        created() {
            this.onResize()
            window.addEventListener('resize', this.onResize)
        },

        computed: {
            selectButtonClass() {
                return 'gh-button gh-button--primary gh-button-outline'
            },
            selected50Style() {
                return (this.choosedImpact === 50)?'background-color: #caf0f1':''
            },
             selected100Style() {
                return (this.choosedImpact === 100)?'background-color: #caf0f1':''
            },
             selected200Style() {
                return (this.choosedImpact === 200)?'background-color: #caf0f1':''
            }
            
        },

        methods: {
            updateRadio (value) {
                this.choosedImpact = value
                this.$emit('updateImpact', this.choosedImpact)
            },
            onResize() {
                if (window.innerWidth > 768) {
                    this.isMobile = false
                } else {
                    this.isMobile = true
                }
            },
            
            handleClick (tab, event) {
                this.choosedImpact = parseInt(tab.name)
                this.updateRadio(this.choosedImpact)
            }
        },

        watch: {
            impact () {
                this.choosedImpact = this.impact;
            }
        }
    }
</script>
<style lang="scss" scoped>
    
    .gh-header {
        line-height: 1;
        font-weight: 500;
        @media (max-width: 767px) {
            padding-bottom: 1rem;
        }
        
    }
    @media screen and (max-width: 375px) {
        .gh-header {
            padding-bottom: 1rem;
        }
    }
    @media screen and (max-width: 767px) {
        .gh-sub-heading {
            color: #24c6dc;
        }
    }
    .gh-impact-table {
        display: flex;
        
        .el-col {
            border-style: solid;
            border-width: 1.5px;
            border-color: #e8e5e5;
            padding: 24px 30px;
            text-align: center;
            font-size: 1.45rem;
        }
    }
    .gh-strong {
        font-weight: 800;
    }
    .gh-table-header {
        font-size: 1.5rem;
        font-weight: 800;
    }
    .gh-cell-heading {
        line-height: 1.3;
        font-size: 1.4rem;
    }
    .gh-mobile-cell-body {
         font-size: 20px;
         margin-bottom: 10px;
    }
    .gh-price {
        color: white;
    }
    .term-checkbox {
        display: flex;
        align-items: flex-start;
        color: white;
    }
    .gh-cell-body {
        padding: .4rem;
        line-height: 1.3;
        font-size: 1.4rem;
    }
    .gh-cell-description {
        font-size: 1rem;
        font-weight: 700;
        margin-top: 1rem;
    }
    .gh-desktop {
        border-style: solid;
        border-width: 1.5px;
        border-color: #e8e5e5;
    }
    .gh-hint {
        font-size: 1.1rem;
        font-weight: 600;
        margin-top: 3rem;
        padding: 1rem 1rem 1rem 2rem;
        border: 3px solid #24c6dc;
    }
    .gh-div-button {
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>
